import { SelectField } from "$components/inputs";
import { Divider, MenuItem } from "@material-ui/core";
import { InventoryItemType } from "elephant-web/gql";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

// `null` = no filter (server returns both pharma and non-pharma).
// We surface it via a sentinel value because <Select/> can't host a `null`
// option directly.
export type ProductOriginFilterValue = InventoryItemType | null;

const ALL_SENTINEL = "ALL";

type SelectValue = InventoryItemType | typeof ALL_SENTINEL;

interface Props {
  value: ProductOriginFilterValue;
  onChange: (value: ProductOriginFilterValue) => void;
}

export const ProductOriginFilter: FC<Props> = ({ value, onChange }) => {
  const { formatMessage } = useIntl();
  return (
    <SelectField
      name="product-origin-filter"
      id="product-origin-filter"
      fullWidth
      hideHelper
      label={formatMessage({
        id: "inventory.productOriginFilter.label",
        defaultMessage: "Item type",
      })}
      selectProps={{
        value: value ?? ALL_SENTINEL,
        onChange: (e: React.ChangeEvent<{ value: SelectValue }>) => {
          const next = e.target.value;
          onChange(next === ALL_SENTINEL ? null : next);
        },
        // makes the chip read out the same label that the option uses
        renderValue: (v) => {
          if (v === InventoryItemType.Pharma) {
            return formatMessage({
              id: "inventory.productOriginFilter.pharma",
              defaultMessage: "Pharma",
            });
          }
          if (v === InventoryItemType.NonPharma) {
            return formatMessage({
              id: "inventory.productOriginFilter.nonPharma",
              defaultMessage: "Non-pharma",
            });
          }
          return formatMessage({
            id: "inventory.productOriginFilter.all",
            defaultMessage: "All",
          });
        },
      }}
    >
      <MenuItem value={ALL_SENTINEL}>
        <FormattedMessage
          id="inventory.productOriginFilter.all"
          defaultMessage="All"
        />
      </MenuItem>
      <Divider />
      <MenuItem value={InventoryItemType.Pharma}>
        <FormattedMessage
          id="inventory.productOriginFilter.pharma"
          defaultMessage="Pharma"
        />
      </MenuItem>
      <MenuItem value={InventoryItemType.NonPharma}>
        <FormattedMessage
          id="inventory.productOriginFilter.nonPharma"
          defaultMessage="Non-pharma"
        />
      </MenuItem>
    </SelectField>
  );
};
